/* global angular */
angular.module('ua5App')
    .factory('SearchFactory', ['$resource', '$rootScope', function($resource, $rootScope) {
        return {
            search: function() {
                return $resource($rootScope.apiDevUrl + 'search');
            },
            searchResources: function() {
                return $resource('data/resource-search.json');
            }
        };
    }])
;
